import * as React from "react"

/** @deprecated - use <RequiredLabel /> instead */
export class RequiredFormInfo extends React.PureComponent {
    render() {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    paddingBottom: "2rem",
                }}>
                <span className="ant-form-item-required">Required</span>
            </div>
        )
    }
}
